import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { clickableCardShellSx } from './clickableCardSx';

type ClickableCardLinkProps = {
  to: string;
  ariaLabel: string;
  sx?: SxProps<Theme>;
  children: React.ReactNode;
};

const ClickableCardLink = ({
  to,
  ariaLabel,
  sx,
  children,
}: ClickableCardLinkProps) => {
  const navigate = useNavigate();

  const handleActivate = useCallback(() => {
    navigate(to);
  }, [navigate, to]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleActivate();
      }
    },
    [handleActivate],
  );

  return (
    <Box
      role="link"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      sx={[
        clickableCardShellSx,
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
};

export default ClickableCardLink;
